// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

const defaultSettings = {
  cookieDuration: 30,
  cookieName: 'gdpr',
  cookieValue: 'accepted',
  cookiesOpenClass: 'is-open',
};

class Cookies {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;

    // Set module dom sub elements e.g.
    this.cta = el.querySelector(settings.cta);

    // Set settings
    this.settings = { ...defaultSettings, ...settings };
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container || !this.cta) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    window.addEventListener('load', () => this.checkCookie(this.settings.cookieName, this.settings.cookieValue));
  };

  handleCookie = () => {
    this.setCookie('gdpr', 'accepted', this.settings.cookieDuration);
    this.container.classList.remove(this.settings.cookiesOpenClass);

    // Removes event listener from the CTA to avoid memory leaks
    setTimeout(() => this.cta.removeEventListener('click', this.handleCookie), 500);
  };

  setCookie = (cname, cvalue, exdays) => {
    const today = new Date();
    today.setTime(today.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${today.toUTCString()}`;
    const path = 'path=/';
    document.cookie = `${cname}=${cvalue};${expires};${path}`;
  };

  checkCookie = (cname, cvalue) => {
    if (document.cookie.indexOf(`${cname}=${cvalue}`) < 0) {
      this.container.classList.add(this.settings.cookiesOpenClass);
      this.cta.addEventListener('click', this.handleCookie);
    }
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, Cookies);
